module.exports = __webpack_public_path__ + "src/assets/games/42/246.jpg";